import * as Yup from 'yup'
import {ShortDescription} from 'Validations'

const Validation = Yup.object({
  jobSearchStatus: Yup.object().nullable().required('Field required'),
  aboutMe: ShortDescription.required('Field required'),
})

export default Validation
